import { compact, find, head } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import { updateDatavizOptions } from "@radarly/models/dataviz";

function getMainUnitOptions(locale: Locale) {
  return compact([
    {
      value: "total",
      label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::RAW_VALUES"),
    },
    {
      value: "percentage",
      label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::PERCENTAGES"),
    },
  ]);
}

function getMainUnitCurrentOption(
  dataviz: DatavizHorizontalBarChart,
  locale: Locale
) {
  const options = getMainUnitOptions(locale);
  const currentOption = find(options, { value: dataviz.mainUnit });
  if (!currentOption) {
    return head(options);
  }
  return currentOption;
}

export function useMainUnit(
  dataviz: DatavizHorizontalBarChart,
  setDataviz: (dataviz: DatavizHorizontalBarChart) => void
) {
  const locale = useCurrentUserLocale();
  const options = getMainUnitOptions(locale);
  const option = getMainUnitCurrentOption(dataviz, locale);
  const onChange = ({ value }: { value: string }) => {
    setDataviz(updateDatavizOptions(dataviz, "mainUnit", value));
  };
  return {
    label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::DISPLAYED_VALUES"),
    options,
    option,
    onChange,
  };
}
